import React, { useEffect, useState } from "react"
import { useOutletContext } from "react-router-dom"
import axios from "axios"
import { FaFileInvoiceDollar } from "react-icons/fa"

export default function CircuitoDespesasPainel() {
  const { circuito } = useOutletContext()
  const [despesas, setDespesas] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (circuito?._id) {
      const token = localStorage.getItem("token")
      axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/despesas`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => setDespesas(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
    }
  }, [circuito])

  const totalDespesas = despesas.reduce((acc, d) => acc + d.valor, 0)

  if (loading) return <div style={{ padding: "40px", color: "#fff" }}>Carregando...</div>

  return (
    <div>
      <div className="pc-page-header">
        <h1 className="pc-page-header__title">
          <FaFileInvoiceDollar style={{ marginRight: 12, color: "#ef4444" }} />
          Despesas do Circuito
        </h1>
        <p className="pc-page-header__subtitle">Histórico de custos registrados para este circuito.</p>
      </div>

      <div style={{ display: "flex", gap: "20px", marginBottom: "24px" }}>
        <div style={{ background: "rgba(239, 68, 68, 0.1)", border: "1px solid rgba(239, 68, 68, 0.3)", padding: "20px", borderRadius: "12px", width: "100%", maxWidth: "300px" }}>
            <h4 style={{ margin: "0 0 10px 0", color: "#fca5a5", fontSize: "14px", textTransform: "uppercase" }}>Total de Custos</h4>
            <span style={{ fontSize: "24px", fontWeight: "bold", color: "#ef4444" }}>
              R$ {totalDespesas.toLocaleString('pt-BR', {minimumFractionDigits: 2})}
            </span>
        </div>
      </div>

      <div className="pc-card" style={{ padding: 0, overflow: "hidden" }}>
        <table className="pc-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left", padding: "15px" }}>Descrição da Despesa</th>
              <th style={{ textAlign: "center" }}>Data do Registro</th>
              <th style={{ textAlign: "right", padding: "15px" }}>Valor</th>
            </tr>
          </thead>
          <tbody>
            {despesas.length === 0 ? (
              <tr><td colSpan="3" style={{ textAlign: "center", padding: "30px", color: "#888" }}>Nenhuma despesa registrada.</td></tr>
            ) : (
              despesas.map(d => (
                <tr key={d._id}>
                  <td style={{ padding: "15px", color: "#fff" }}>{d.descricao}</td>
                  <td style={{ textAlign: "center", color: "#aaa" }}>{new Date(d.dataCriacao).toLocaleDateString("pt-BR")}</td>
                  <td style={{ textAlign: "right", padding: "15px", color: "#ef4444", fontWeight: "bold" }}>
                    - R$ {d.valor.toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}